import { call, put } from "redux-saga/effects";
import { eventAlbumSelectionConstants as C } from "../actions/constants/eventAlbumSelectionConstants";
import eventAlbumSelectionService from "../services/eventAlbumSelectionService";
import { commonActions } from "../actions/commonAction";

function* fetchAlbumWorkspaceSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(eventAlbumSelectionService.fetchAlbumWorkspace, action.payload);
    if (response?.success) {
      yield put({ type: C.fetchWorkspaceSuccess, payload: response.resultObject });
    } else {
      const msg = response?.message || "Failed to fetch album workspace";
      yield put({ type: C.fetchWorkspaceFailure, payload: msg });
      yield put(commonActions.errorResponse(msg));
    }
  } catch (error: any) {
    const msg = error?.message || "An error occurred";
    yield put({ type: C.fetchWorkspaceFailure, payload: msg });
    yield put(commonActions.errorResponse(msg));
  }
}

function* fetchAlbumSelectionSummarySaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(eventAlbumSelectionService.fetchAlbumSelectionSummary, action.payload);
    if (response?.success) {
      yield put({ type: C.fetchSummarySuccess, payload: response.resultObject });
    } else {
      const msg = response?.message || "Failed to fetch album selection summary";
      yield put({ type: C.fetchSummaryFailure, payload: msg });
      yield put(commonActions.errorResponse(msg));
    }
  } catch (error: any) {
    const msg = error?.message || "An error occurred";
    yield put({ type: C.fetchSummaryFailure, payload: msg });
    yield put(commonActions.errorResponse(msg));
  }
}

// Single saga for all workflow transitions
function* changeAlbumStatusSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(eventAlbumSelectionService.changeAlbumStatus, action.payload);
    if (response?.success) {
      yield put({ type: C.changeStatusSuccess, payload: response.resultObject });
      // Refresh workspace after any transition
      yield put({ type: C.fetchWorkspaceRequest, payload: { eventId: action.payload.eventId, studioId: action.payload.studioId } });
    } else {
      const msg = response?.message || "Failed to update album status";
      yield put({ type: C.changeStatusFailure, payload: msg });
      yield put(commonActions.errorResponse(msg));
    }
  } catch (error: any) {
    const msg = error?.message || "An error occurred";
    yield put({ type: C.changeStatusFailure, payload: msg });
    yield put(commonActions.errorResponse(msg));
  }
}
function* listCuratedMediaSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(eventAlbumSelectionService.listCuratedMedia, action.payload);
    if (response?.success) {
      yield put({ type: C.listCuratedSuccess, payload: response.resultObject });
    } else {
      const msg = response?.message || "Failed to list curated media";
      yield put({ type: C.listCuratedFailure, payload: msg });
      yield put(commonActions.errorResponse(msg));
    }
  } catch (error: any) {
    const msg = error?.message || "An error occurred";
    yield put({ type: C.listCuratedFailure, payload: msg });
    yield put(commonActions.errorResponse(msg));
  }
}

function* listCuratedMediaMoreSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(eventAlbumSelectionService.listCuratedMedia, action.payload);
    if (response?.success) {
      yield put({ type: C.listCuratedMoreSuccess, payload: response.resultObject });
    } else {
      yield put({ type: C.listCuratedFailure, payload: response?.message || "Failed to load more curated media" });
    }
  } catch (error: any) {
    yield put({ type: C.listCuratedFailure, payload: error?.message || "An error occurred" });
  }
}

function* validateCustomerAccessSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(eventAlbumSelectionService.validateCustomerAccess, action.payload);
    if (response?.success) {
      yield put({ type: C.customerValidateSuccess, payload: response.resultObject });
    } else {
      yield put({ type: C.customerValidateFailure, payload: response?.message || "Invalid or expired access code" });
    }
  } catch (error: any) {
    yield put({ type: C.customerValidateFailure, payload: error?.message || "An error occurred" });
  }
}

function* customerSubmitSelectionSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(eventAlbumSelectionService.customerSubmitSelection, action.payload);
    if (response?.success) {
      yield put({ type: C.customerSubmitSuccess, payload: response.resultObject });
    } else {
      yield put({ type: C.customerSubmitFailure, payload: response?.message || "Failed to submit selection" });
    }
  } catch (error: any) {
    yield put({ type: C.customerSubmitFailure, payload: error?.message || "An error occurred" });
  }
}

function* addRemainingPhotosSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(eventAlbumSelectionService.addRemainingPhotos, action.payload);
    if (response?.success) {
      yield put({ type: C.addRemainingSuccess, payload: response.resultObject });
      yield put({ type: C.fetchWorkspaceRequest, payload: { eventId: action.payload.eventId, studioId: action.payload.studioId } });
    } else {
      const msg = response?.errorMessage || "Failed to add remaining photos";
      yield put({ type: C.addRemainingFailure, payload: msg });
      yield put(commonActions.errorResponse(msg));
    }
  } catch (error: any) {
    const msg = error?.message || "An error occurred";
    yield put({ type: C.addRemainingFailure, payload: msg });
    yield put(commonActions.errorResponse(msg));
  }
}

function* addToSelectedSaga(action: any): Generator<any, void, any> {
    try {
        const response = yield call(
            eventAlbumSelectionService.addToSelectedService,
            action.payload,
        );
        if (response?.success) {
            yield put({ type: C.addToSelectedSuccess, payload: response.resultObject });
             yield put(commonActions.successResponse(response.message));
        } else {
            const msg = response?.errorMessage || "Failed to add selected photos";
            yield put({ type: C.addToSelectedFailure, payload: msg });
            yield put(commonActions.errorResponse(msg));
        }
    } catch (error: any) {
        const msg = error?.message || "An error occurred";
        yield put({ type: C.addToSelectedFailure, payload: msg });
        yield put(commonActions.errorResponse(msg));
    }
}

function* addToBackgroundSaga(action: any): Generator<any, void, any> {
    try {
        const response = yield call(
            eventAlbumSelectionService.addToBackgroundService,
            action.payload,
        );
        if (response?.success) {
            yield put({ type: C.addToBackgroundSuccess, payload: response.resultObject });
             yield put(commonActions.successResponse(response.message));
        } else {
            const msg = response?.errorMessage || "Failed to add remaining photos";
            yield put({ type: C.addToBackgroundFailure, payload: msg });
            yield put(commonActions.errorResponse(msg));
        }
    } catch (error: any) {
        const msg = error?.message || "An error occurred";
        yield put({ type: C.addToBackgroundFailure, payload: msg });
        yield put(commonActions.errorResponse(msg));
    }
}
function* listSelectedSaga(action: any): Generator<any, void, any> {
    try {
        const response = yield call(
            eventAlbumSelectionService.listSelectedService,
            action.payload,
        );
        if (response?.success) {
            yield put({ type: C.listSelectedSuccess, payload: response.resultObject });
        } else {
            const msg = response?.errorMessage || "Failed to add listed selected";
            yield put({ type: C.listSelectedFailure, payload: msg });
            yield put(commonActions.errorResponse(msg));
        }
    } catch (error: any) {
        const msg = error?.message || "An error occurred";
        yield put({ type: C.listSelectedFailure, payload: msg });
        yield put(commonActions.errorResponse(msg));
    }
}



export const eventAlbumSelectionSaga = {
  fetchAlbumWorkspaceSaga,
  fetchAlbumSelectionSummarySaga,
  changeAlbumStatusSaga,
  listCuratedMediaSaga,
  listCuratedMediaMoreSaga,
  validateCustomerAccessSaga,
  customerSubmitSelectionSaga,
  addRemainingPhotosSaga,
  addToSelectedSaga,
  addToBackgroundSaga,
  listSelectedSaga
};
